// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper_3aMHC","content":"NotFound_content_1T38i","search":"NotFound_search_19GW-"};